import { getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";
import BrandLogo from "./BrandLogo";

type HeaderBrandProps = {
  variant?: "default" | "header" | "sidebar";
  linkTo?: string;
};

export default function HeaderBrand({ variant = "default", linkTo }: HeaderBrandProps) {
  const componentClasses = getThemeComponentClasses();
  const textClassName =
    variant === "header"
      ? componentClasses?.header?.brandTextColor
      : variant === "sidebar"
        ? componentClasses?.sidebar?.brandTextColor
        : "";

  return <BrandLogo textClassName={textClassName || undefined} linkTo={linkTo} />;
}
